import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { News } from '../../shared/model/news.model';

@Component({
    selector: 'mgp-modal-news-detail',
    templateUrl: './news-detail.component.html'
})
export class NewsDetailComponent {
    news?: News;

    constructor(public activeModal: NgbActiveModal) {}
}